import http from '@/http-common'

class EmployeeAlbumKpiService {
  getKpi(params) {
    return http.get('statistics/employee-album/kpi', { params })
  }
}

export default new EmployeeAlbumKpiService()
